import { ScanLine, MessageSquareText, Dumbbell } from "lucide-react";

const features = [
  {
    icon: ScanLine,
    title: "Analyse du physique par IA",
    description:
      "Prends une photo de ton corps. Notre intelligence artificielle l'analyse en quelques secondes pour évaluer ta symétrie, ta définition et ton volume musculaire.",
    accent: "from-violet-500/20 to-transparent",
  },
  {
    icon: MessageSquareText,
    title: "Notes et feedback personnalisés",
    description:
      "Reçois un score détaillé et des retours précis sur chaque groupe musculaire. Comprends ce qui fonctionne et ce qui peut être amélioré.",
    accent: "from-violet-500/20 to-transparent",
  },
  {
    icon: Dumbbell,
    title: "Programme de musculation personnalisé",
    description:
      "Un plan d'entraînement sur-mesure, généré selon ton physique, tes objectifs et ton équipement. Progresse efficacement, semaine après semaine.",
    accent: "from-violet-500/20 to-transparent",
  },
];

export default function Features() {
  return (
    <section
      id="fonctionnalites"
      data-testid="features-section"
      className="py-24 lg:py-32 px-6 lg:px-10 bg-white"
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mb-16 lg:mb-20">
          <p
            data-testid="features-eyebrow"
            className="text-sm font-medium text-violet-600 mb-4 uppercase tracking-wider"
          >
            Fonctionnalités
          </p>
          <h2
            data-testid="features-title"
            className="text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.1] text-neutral-950"
          >
            L'intelligence artificielle au service de ton corps.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {features.map((f, i) => (
            <div
              key={f.title}
              data-testid={`feature-card-${i}`}
              className="group relative bg-neutral-50 border border-neutral-200 rounded-3xl p-8 transition-all duration-300 hover:-translate-y-1 hover:border-violet-500/50 hover:shadow-[0_20px_60px_-15px_rgba(124,58,237,0.25)]"
            >
              <div
                className={`absolute inset-0 rounded-3xl bg-gradient-to-br ${f.accent} opacity-0 group-hover:opacity-100 transition-opacity duration-500`}
              />
              <div className="relative">
                <div className="w-12 h-12 rounded-2xl bg-white border border-neutral-200 flex items-center justify-center mb-6 group-hover:border-violet-500/50 group-hover:bg-violet-500 transition-all duration-300">
                  <f.icon
                    size={22}
                    className="text-neutral-950 group-hover:text-white transition-colors"
                  />
                </div>
                <h3 className="text-xl font-semibold tracking-tight text-neutral-950 mb-3">
                  {f.title}
                </h3>
                <p className="text-base text-neutral-600 leading-relaxed">
                  {f.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
